export default {
    update: "Обновить",
    titleService: "Сервисы",
    titlePlugin: "Плагины",
    columns: {
        name: "Сервис",
        version: "Версия",
    },
    notification: {
        load_error: "Ошибка загрузки",
        connection_error: "Не удалось получить актуальную информацию по обновлениям\n так как нет подключение к серверу обновлений",
        add_ok: "Запрос успешно отправлен",
        add_error: "Ошибка запроса",
        delete_ok: "Запрос успешно отправлен",
        delete_error: "Ошибка запроса",
    },
}